<template>
  <Container type="card-full" v-loading="loading">
    <div slot="header">
      <el-button type="primary" @click="confirm" :loading="btnLoading" v-if="+psu.psubmpayflg === 0 && +psu.psubmpaytype === 3">确认</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
        <el-form :model="psu" label-position="right" class="mainfrom">
            
            <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【缴费信息】</div>
            </div>
            <el-form-item label="是否缴费" class="from-value" v-if="!psu.psubmpaychecktime">
              <el-radio-group v-model="psuobj.psubmpayflg" class="value" style="margin-top:14px" >
                  <el-radio :label="1">已收</el-radio>
                  <el-radio :label="2">未收</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="row">
                <el-form-item label="项目编号" class="from-value">
                    {{psu.projectcode}}
                </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="项目名称" class="from-value">
                  {{psu.projectname}}
              </el-form-item>
            </div>
            <el-form-item label="供应商" class="from-value">
                {{psu.comfullname}}
            </el-form-item>
            <el-form-item label="报名费" class="from-value">
                {{setThousand(psu.psubmamt)}}
            </el-form-item>
            <el-form-item label="支付方式" class="from-value">
                {{Number(psu.psubmpaytype) === 3 ? '线下支付' : (Number(psu.psubmpaytype) === 1 ? '支付宝支付':'微信支付')}}
            </el-form-item>
            <el-form-item label="报名费凭证" v-if="Number(psu.psubmpaytype) === 3">
              <popover-img :img-src="psu.psubmpayurl ? uploadAddr + psu.psubmpayurl:''"
                           default-height="150"></popover-img>
                <!--<upload-pic-one @changed='setfile' :picUrl='psu.psubmpayurl' folderName='web' text="选择图片"></upload-pic-one>-->
            </el-form-item>
            <el-form-item label="交易单号" class="from-value"  v-if="Number(psu.psubmpaytype) !== 3">
                {{psu.psubmpaytradeno}}
            </el-form-item>
            <div v-show='psu.psubmpayflg === 1' class="row">
              <el-form-item label="收款状态" class="from-value">
                  {{+psuobj.psubmpayflg === 1 ? '已收':'未收'}}
              </el-form-item>
              <el-form-item label="收款人" class="from-value">
                <div v-if="+psu.psubmpaytype === 1 || +psu.psubmpaytype === 2">
                    线上支付
                </div>
                <div v-else>
                  {{psu.psubmpaycheckusername}}
                </div>
              </el-form-item>
              <el-form-item label="收款时间" class="from-value">
                  {{psu.psubmpaychecktime}}
              </el-form-item>
            </div>
            <div class="split-box">
              <div class="split-line"></div>
              <div class="split-name">【开票信息】</div>
            </div>
            <el-form-item label="报名联系人" class="from-value">
                {{psu.psucontactname}}
            </el-form-item>
            <el-form-item label="报名电话" class="from-value">
                {{psu.psucontactphone}}
            </el-form-item>
            <el-form-item label="单位电话" class="from-value">
                {{psu.comtel}}
            </el-form-item>
            <el-form-item label="联系邮箱" class="from-value">
                {{psu.psucontactmail}}
            </el-form-item>
            <el-form-item label="信用代码" class="from-value">
                {{psu.comidcode}}
            </el-form-item>
            <el-form-item label="单位地址" class="from-value">
                {{psu.comaddr}}
            </el-form-item>
            <el-form-item label="开户银行" class="from-value">
                {{psu.combank}}
            </el-form-item>
            <el-form-item label="开户账号" class="from-value">
                {{psu.combanknumber}}
            </el-form-item>
            <el-form-item label="开票申请备注" class="from-value">
                {{psu.psuInvoicmark}}
            </el-form-item>
            <div class="view-container">
              <div class="view-box" v-if="(+psu.projectstopflg === 1 || +psu.projectcancelflg === 1) && +psu.psubminvoiceflg === 1">
                  <div class="split-box">
                    <div class="split-line"></div>
                    <div class="split-name">【退款信息】</div>
                  </div>
                  <div>
                    <div class="view-row" v-if="+psu.psubmreturnflg != 1">
                      <div class="view-field" >
                        <div class="view-label"></div>
                        <div class="view-value">
                          <el-button type="primary" @click="returnbmf" :loading="btnLoading">原路退回报名费</el-button>
                        </div>
                      </div>
                    </div>
                    <div class="view-row" v-if="+psu.psubmreturnflg === 1 && +psu.psubmpaytype !== 3">
                      <div class="view-field" >
                        <div class="view-label">退回单号</div>
                        <div class="view-value">{{psu.psubmreturntradeno}}</div>
                      </div>
                    </div>
                    <div class="view-row"  v-if="+psu.psubmreturnflg === 1">
                      <div class="view-field" >
                        <div class="view-label">退回状态</div>
                        <div class="view-value">
                          {{+psu.psubmreturnflg === 1 ? '已退回':'未退回'}}
                        </div>
                      </div>
                      <div class="view-field">
                        <div class="view-label">退回确认人</div>
                        <div class="view-value">{{psu.psubmreturnusername}}</div>
                      </div>
                      <div class="view-field">
                        <div class="view-label">退回时间</div>
                        <div class="view-value">{{psu.psubmreturntime | newDate}}</div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div v-if="+psuobj.psubmreturnflg !== 1">
                <div v-if="+psuobj.psubmpayflg === 1">
                  <div class="split-box">
                    <div class="split-line"></div>
                    <div class="split-name">【发票登记】</div>
                  </div>
                  <el-form-item label="发票号" class="from-value">
                      <div v-if="+kpflg" style="display:flex;">
                        <el-input  v-model="psubminvoicenum" placeholder="请输入开票号" />
                        <el-button @click="confirminvoice" type='primary'>确认</el-button>
                      </div>
                      <div v-else>
                        <span>{{psu.psubminvoicenum}}</span> <el-button @click="changekpflg" type='primary' style="margin-left:30px;">登记</el-button>
                      </div>
                  </el-form-item>
                  <div>
                    <el-form-item label="开票人" class="from-value" v-if="psu.bminvoicerusername">
                        {{psu.bminvoicerusername}}
                    </el-form-item>
                    <el-form-item label="开票时间" class="from-value" v-if="psu.psubminvoicetime">
                        {{psu.psubminvoicetime}}
                    </el-form-item>
                  </div>
                  <!-- <el-form-item label=" " class="from-value">
                      <el-button @click="confirminvoice" type='primary' v-if="+kpflg === 1">确认</el-button>
                      <el-button @click="changekpflg" type='primary'  v-else>登记</el-button>
                  </el-form-item> -->
                </div>
            </div>
        </el-form>

    </div>
    <el-dialog
      title="填写发票号"
      :visible.sync="dialogVisible"
      width="70%">
      <div style="display: flex;align-items: center;margin-left:60px;">
        <div style="margin-right:10px;">发票号</div>
        <div style="width:60%">
          <el-input  v-model="psubminvoicenum" placeholder="请输入内容" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirminvoice">确 定</el-button>
      </span>
    </el-dialog>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  import popoverImg from '../common/popoverImg'
  export default {
    name: "psuBmfAffirmForm",
    data () {
      return {
        psu: {},
        psuobj:this.$route.params.form,
        type: Number(this.$route.params.type),
        psubminvoicenum:'',
        kpflg:false,
        dialogVisible:false,
        btnLoading: false,
        disabled:false,
        loading:false,
        returnpay:{}
      }
    },
    created () {
    },
    activated () {
      this.init()
      this.getpageInfo()
    },
    mounted(){
    },
    watch: {},
    filters: {
      newDate(value){
        return utils.formatterDate(value, 'yyyy-MM-dd HH:mm:ss')
      }
    },
    components: {uploadPicOne, popoverImg},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.psu = {}
        this.psuobj = this.$route.params.form
        this.dialogVisible = false
        this.psubminvoicenum = ''
        this.btnLoading = false
        this.kpflg = false
        // if(+this.psu.psubmpayflg === 0){
        //   this.disabled = true
        // }
      },
      async showinvoicetext(){
        this.dialogVisible = true
      },
      async changekpflg(){
        this.kpflg = true
      },
      async confirminvoice(){
        
        if(!this.psubminvoicenum){
          this.$message.warning('请输入发票号');
          return
        }
        
        let form = {}
        form.userid = this.$store.getters.loginUser.userid
        form.psuid = this.psuobj.psuid
        form.psubminvoicenum = this.psubminvoicenum
        this.loading = true
        let res = await request({
            method: 'post',
            url: '/cwgl/psuproject/saveinvoice',
            data: form
        })
        if(+res.issuccess === 1){
          this.$message.success('确认成功')
          this.getpageInfo()
          this.kpflg = false
          this.dialogVisible = false
          return
        }
        this.loading = false
      },
      async getpageInfo(){
        this.loading = true
        let res = await request({
            method: 'get',
            url: '/cwgl/psuproject/getpageInfo',
            params: {psuid: this.psuobj.psuid}
        })
        this.psu = res[0]
        this.psu.psubmpaychecktime = utils.formatterDate(res[0].psubmpaychecktime,'yyyy-MM-dd HH:mm:ss')
        this.psu.psubminvoicetime = utils.formatterDate(res[0].psubminvoicetime,'yyyy-MM-dd HH:mm:ss')
        this.loading = false
      },
      async setfile (path) {
        this.psu.psubmpayurl = path.replace(this.uploadAddr, '')
      },
      async confirm(){
          if(+this.psuobj.psubmpayflg === 0){
            this.$message.warning('请先选择是否缴费')
            return
          }
          this.loading = true
          this.$confirm('是否确认?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
              let model = {}
              model.psuid = this.psuobj.psuid
              model.psubmpaycheckuserid = this.$store.getters.loginUser.userid
              model.psubmpayflg = this.psuobj.psubmpayflg
              let res = await request({
                method: 'post',
                url: '/cwgl/psuproject/checkbmpay',
                data: model
              })
              if (res.issuccess === 1) {
                this.$message.success('报名费确认成功')
                this.getpageInfo()
              } else {
                this.$message.error('报名费确认失败')
              }
              }).catch(() => {
            })
          this.loading = false
      },
      async returnbmf(){
        this.$confirm('报名费退回', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.btnLoading = true
          this.returnpay.returnMoneyType = 1
          this.returnpay.type = Number(this.psu.psubmpaytype)
          this.returnpay.out_trade_no = this.psu.psubmpayno  //out_trade_no: '商户内部订单号',
          this.returnpay.out_refund_no = this.psu.psubmpaytradeno // out_refund_no: '商户内部退款单号'
          this.returnpay.cosmerchantNumber = this.$store.state.user.loginUser.cosmerchantNumber
          this.returnpay.coswxPublicAccountId = this.$store.state.user.loginUser.coswxPublicAccountId
          this.returnpay.coswxPublicKey = this.$store.state.user.loginUser.coswxPublicKey
          this.returnpay.coswxSecurityPrivateKey = this.$store.state.user.loginUser.coswxSecurityPrivateKey
          this.returnpay.cosalipayApplicationId = this.$store.state.user.loginUser.cosalipayApplicationId
          this.returnpay.cosalipayPublicKey = this.$store.state.user.loginUser.cosalipayPublicKey
          this.returnpay.cosalipayPrivateKey = this.$store.state.user.loginUser.cosalipayPrivateKey
          if(Number(this.psu.psubmpaytype) === 1){
            this.returnpay.total_fee = this.psu.projectbmamt
            this.returnpay.refund_fee = this.psu.projectbmamt
          }
          else if(Number(this.psu.psubmpaytype) === 2){
            this.returnpay.total_fee = this.psu.projectbmamt * 100
            this.returnpay.refund_fee = this.psu.projectbmamt * 100
          }
          this.returnpay.psuid = this.psu.psuid
          this.returnpay.psubmreturnflg = 1
          this.returnpay.psubmreturnuserid = this.$store.getters.loginUser.userid
          
          let data = await request({
            url: '/common/refund',
            method: "post",
            data: this.returnpay
          })
          this.getpageInfo()
          this.$message.success(data['issuccess'])
          this.btnLoading = false
          return
        }).catch(() => {
        })
      }
    }
  }
</script>

<style scoped lang="scss">

  .form {
    display: flex;
    align-items: center;
  }
  .split-box{
    margin: 11px 0 15px;
    .split-line{
      margin: 5px;
    }
    .split-name{
      font-weight: bold;
    }
  }
</style>
